module.exports = __webpack_public_path__ + "static/img/wealth_level_69.e74e049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_69.png
// module id = q2hD
// module chunks = 0